import { useRef } from "react";
import { createPortal } from "react-dom";
import { useTips } from "../../../../../common/GlobalTips";
import { useTranslation } from "react-i18next";



const ThreeJSOverlay = ({ children, close, openThreeWrapper, dragging, rangeDragging }) => {
  const mainRef = useRef(null)
  const tip = useTips()
  const { t } = useTranslation();

  const handleClick = (e) => {
    if (dragging || rangeDragging) return
    if (mainRef.current && mainRef.current.contains(e.target)) return

    if (openThreeWrapper.upload) {
      close()
    } else {
      tip({
        type: 'primary',
        content: t('TIP_PRIMARY_CHANGE_NOT_SAVE'),
        yes: () => close(),
        no: (f) => f,
      });
    }
  }

  return createPortal(<div id='threeJsOverlay' className={`fixed inset-0
  ${openThreeWrapper.status ? "pointer-events-all z-[2000] [transition:z-index_0.3s_ease]" : "pointer-events-none z-[-1] [transition:z-index_0.3s_ease_0.3s]"}`} onClick={handleClick}>
    <div ref={mainRef}>
      {children}
    </div>
  </div>, document.body);
};

export default ThreeJSOverlay